export default __webpack_public_path__ + "static/media/Logo-Bosque-Capital.58780456.png";